import { render, staticRenderFns } from "./AvailableConversationTicketsListView.vue?vue&type=template&id=651d9b2c&scoped=true&"
import script from "./AvailableConversationTicketsListView.vue?vue&type=script&lang=js&"
export * from "./AvailableConversationTicketsListView.vue?vue&type=script&lang=js&"
import style0 from "./AvailableConversationTicketsListView.vue?vue&type=style&index=0&id=651d9b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d9b2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
